const isLabelledOption = (option) => typeof option === 'object' &&
    option !== null &&
    'value' in option &&
    'label' in option;
/** What a picked option stores. */
const optionValue = (option) => isLabelledOption(option) ? String(option.value) : String(option ?? '');
/**
 * What an option shows. viewAs, when the field has one, is given the stored
 * value — the same thing the list view hands it — so one formatter serves both.
 */
const optionDisplay = (option, viewAs) => {
    const value = optionValue(option);
    if (viewAs)
        return viewAs(value);
    return isLabelledOption(option) ? option.label : value;
};
/** What a stored value shows: its option's label, or the value itself. */
const valueDisplay = (value, options) => {
    const option = options.find((o) => isLabelledOption(o) && String(o.value) === String(value));
    return isLabelledOption(option) ? option.label : String(value ?? '');
};
export { isLabelledOption, optionDisplay, optionValue, valueDisplay };
//# sourceMappingURL=selectOptions.js.map